module.exports = __webpack_public_path__ + "static/img/dynamicn.a8ce1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicn.png
// module id = lEDX
// module chunks = 45